<template>
  <div class="lang-switch">
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        {{ currentLang }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh">中文</el-dropdown-item>
        <el-dropdown-item command="en">English</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'LangSwitch',
  computed: {
    currentLang () {
      return this.$i18n.locale === 'zh' ? '中文' : 'English'
    }
  },
  methods: {
    handleCommand (command) {
      // 如果选择的语言与当前语言不同，才进行切换和刷新
      if (this.$i18n.locale !== command) {
        this.$i18n.locale = command
        localStorage.setItem('language', command)
        // 添加页面刷新
        window.location.reload()
      }
    }
  }
}
</script>

<style scoped>
.lang-switch {
  display: inline-block;
  margin-left: 15px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/components/base/LangSwitch.vue